var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusnew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.114,
    cy: 8.254,
    rx: 8.114,
    ry: 8.254,
    opacity: 0.18,
    transform: "translate(3 7.307)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.564 15.757c-5.07 0-8.004-1.177-8.183-1.247a.487.487 0 0 1-.262-.645.473.473 0 0 1 .634-.266c.083.028 6.585 2.606 16.973-.028a.469.469 0 0 1 .578.364c.055.266-.096.533-.358.589-3.637.924-6.792 1.233-9.382 1.233zM24.822 9.69H7.629a.492.492 0 0 1-.482-.491c0-.267.22-.49.482-.49h17.193c.262 0 .482.223.482.49 0 .266-.207.49-.482.49z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.615 23.366H7.767a.706.706 0 0 1-.69-.701V5.808c0-.995.8-1.808 1.778-1.808h14.686c.978 0 1.777.813 1.777 1.808V22.72a.718.718 0 0 1-.703.645zm-16.573-.981h16.312V5.808a.813.813 0 0 0-.813-.827H8.855a.813.813 0 0 0-.813.827v16.577z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#AB317D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.21 21.292c-.977 0-1.763-.799-1.763-1.794s.786-1.794 1.764-1.794 1.763.8 1.763 1.794c0 .995-.785 1.794-1.763 1.794zm0-2.747a.955.955 0 0 0-.936.953c0 .519.427.953.937.953s.937-.434.937-.953a.946.946 0 0 0-.937-.953zM21.157 21.292c-.978 0-1.763-.799-1.763-1.794s.785-1.794 1.763-1.794c.979 0 1.764.8 1.764 1.794 0 .995-.785 1.794-1.764 1.794zm0-2.747a.955.955 0 0 0-.936.953c0 .519.427.953.936.953.51 0 .937-.434.937-.953a.946.946 0 0 0-.937-.953z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.351 12.702a.492.492 0 0 1-.482-.49V9.268c0-.266.22-.49.482-.49s.482.224.482.49v2.942c0 .28-.206.49-.482.49zM5.962 12.702a.492.492 0 0 1-.482-.49V9.268c0-.266.22-.49.482-.49s.482.224.482.49v2.942c0 .28-.207.49-.482.49zM19.256 7.153h-6.13a.41.41 0 0 1-.414-.42c0-.239.18-.42.414-.42h6.13a.41.41 0 0 1 .414.42.41.41 0 0 1-.414.42zM10.315 26h-1.35c-.785 0-1.433-.659-1.433-1.457v-.449c0-.266.22-.49.483-.49.261 0 .482.224.482.49v.449c0 .266.206.476.468.476h1.35c.262 0 .469-.21.469-.476v-.449c0-.266.22-.49.482-.49s.482.224.482.49v.449c0 .812-.634 1.457-1.433 1.457zM23.417 26h-1.35c-.786 0-1.433-.659-1.433-1.457v-.449c0-.266.22-.49.482-.49s.482.224.482.49v.449c0 .266.207.476.469.476h1.35c.262 0 .468-.21.468-.476v-.449c0-.266.22-.49.482-.49s.483.224.483.49v.449c0 .812-.634 1.457-1.433 1.457z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#AB317D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.793 20.703a.41.41 0 0 1-.414-.42v-1.415c0-.239.18-.42.414-.42a.41.41 0 0 1 .413.42v1.415a.41.41 0 0 1-.413.42zM16.184 20.703a.41.41 0 0 1-.413-.42v-1.415c0-.239.179-.42.413-.42a.41.41 0 0 1 .413.42v1.415a.41.41 0 0 1-.413.42zM17.576 20.703a.41.41 0 0 1-.414-.42v-1.415c0-.239.18-.42.414-.42a.41.41 0 0 1 .413.42v1.415a.41.41 0 0 1-.413.42z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusnew);
export default __webpack_public_path__ + "static/media/busnew.cbd57fd81ed57320929624814e177a87.svg";
export { ForwardRef as ReactComponent };